import type { QueryClient } from '@tanstack/react-query';
import { MASTER_DATA_QUERY_KEYS } from '../hooks/useMasterData';

/** Every query key whose data is owned by the server and never mutated locally. */
const SERVER_OWNED_QUERY_KEYS: string[] = ['product-catalog', ...MASTER_DATA_QUERY_KEYS];

/**
 * Runs once per app start, right after the persisted cache has been restored
 * from IndexedDB. Marks the server-owned queries stale and refetches them so
 * backend changes (re-uploaded logos, deactivated master data) reach the client
 * without a logout/login — the 4h poll only fires while the app stays open that
 * long (VIVATISPDB-435, VIVATISPDB-452).
 *
 * Offline-first stays intact: when offline nothing is invalidated, the UI
 * keeps rendering the restored snapshot, and a failed background refetch
 * never discards existing data. refetchType 'all' is required because the
 * restore finishes before any observer mounts and refetchOnMount is false.
 */
export function refreshServerDataAfterRestore(queryClient: QueryClient): void {
  if (typeof navigator !== 'undefined' && !navigator.onLine) return;

  for (const key of SERVER_OWNED_QUERY_KEYS) {
    queryClient.invalidateQueries({ queryKey: [key], refetchType: 'all' });
  }
}
